import React, { ReactNode } from 'react'
import { SnackbarProvider as NotistackSnackbarProvider } from 'notistack'
import { CssBaseline } from '@mui/material'
import { styled } from '@mui/system'
import { ThemeProvider, Theme } from '@mui/material/styles'

import { SnackbarProvider } from 'src/components/snackbar/internals'
import { theme as defaultTheme } from 'src/theme'
import 'src/assets/fonts'
import injectGlobalStyles from './injectGlobalStyles'

export interface KycProviderProps {
  /**
   * If you want to extend the global styles set to `true` and inject them
   * manually via `injectGlobalStyles`.
   */
  disableInjection?: boolean
  /** Custom theme object. */
  theme?: Theme
  /**
   * If you use notistack, maxSnack means maximum snackbars that can be stacked on top of one another.
   */
  maxSnack?: number
  children?: ReactNode
}

const StyledSnackbarProvider = styled(NotistackSnackbarProvider)`
  &.SnackbarItem-contentRoot {
    padding: 0;
    min-width: 0;
    box-shadow: none;
    background-color: transparent;

    .SnackbarItem-message {
      padding: 0;
    }
  }
`

const { inputGlobalStyles } = injectGlobalStyles()
const KycProvider: React.FC<KycProviderProps> = ({
  children,
  disableInjection,
  theme = defaultTheme,
  maxSnack = 3
}) => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <StyledSnackbarProvider maxSnack={maxSnack}>
        {!disableInjection && inputGlobalStyles}
        <SnackbarProvider>{children}</SnackbarProvider>
      </StyledSnackbarProvider>
    </ThemeProvider>
  )
}

KycProvider.displayName = 'KycProvider'

export default KycProvider
